import Listing from "../Listing";
import React, { useEffect } from "react";
import Header from "../../../layout/Header";
import Footer from "../../../layout/Footer";
import HeroSection from "../../../layout/HeroSection";
import Loader from "../../../components/other/Loader";
import { useDispatch, useSelector } from "react-redux";
import { pageRoutes } from "../../../routes/pageRoutes";
import { fetchlessonGearRatios } from "../../../redux/action/lessonsAction";
import SecureContent from "../../../components/secureContent";

const GearRatiosAndMechanisms = () => {
  const dispatch = useDispatch();
  const { gearRatiosList, isLoading } = useSelector(
    (state) => state?.lessonsReducer
  );
 
  useEffect(() => {
    dispatch(fetchlessonGearRatios());
  }, []);


  if (isLoading) {
    return <Loader />;
  }
  
  return (
    <>
      <div>
      <SecureContent/>
      <Header />
        <HeroSection
          label={<h1 class="mb-3">{"Gear ratios and mechanisms"}</h1>}
          breadcrumbItems={[
            { name: "Home", path: `${pageRoutes?.home}/` },
            {
              name: "Gear ratios and mechanisms",
              path: `${pageRoutes?.home}/`,
            },
          ]}
        />

        <Listing contentData={gearRatiosList}  />

        <Footer />
      </div>
    </>
  );
};

export default GearRatiosAndMechanisms;
